import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from 'widgets/Input';
import Icon from 'components/Icon';
import MaterialIcon from '@mdi/react';
import { mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js';
import './LabelledInput.scss';

class LabelledInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
    };
  }

  togglePasswordVisibility = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword,
    }));
  };

  handleType = (type, showPassword) => {
    if (type !== 'password') {
      return type;
    }

    return showPassword ? 'text' : 'password';
  };

  render() {
    const {
      name,
      labelText,
      value,
      onEnter,
      onChange,
      iconName,
      placeholder,
      type,
      errorText,
      autoFocus,
      errorStyle,
      id,
      disabled,
    } = this.props;

    const { showPassword } = this.state;

    return (
      <React.Fragment>
        <div className="LabelledInput__Label">
          {iconName && <Icon name={iconName} />}
          <span className="LabelledInput__Label__Text">{labelText}</span>
        </div>
        <div className="InputContainer">
          <Input
            className={errorText ? 'LabelledInput__Input--Error' : 'LabelledInput__Input'}
            name={name}
            style={{ width: '100%' }}
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            type={this.handleType(type, showPassword)}
            onKeyUp={(event) => event.keyCode === 13 && onEnter()}
            autoFocus={autoFocus}
            id={id}
            disabled={disabled}
          />
          <div className="IconContainer__Password" onClick={this.togglePasswordVisibility}>
            {type === 'password' && (
              <MaterialIcon
                path={showPassword ? mdiEyeOffOutline : mdiEyeOutline}
                color="#7d7d7d"
                size={1}
              />
            )}
          </div>
        </div>
        <div className="LabelledInput__ValidationMsg" style={errorStyle}>
          {errorText}
        </div>
      </React.Fragment>
    );
  }
}

LabelledInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  name: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  labelText: PropTypes.string,
  value: PropTypes.string.isRequired,
  type: PropTypes.string,
  errorText: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  onEnter: PropTypes.func.isRequired,
  errorStyle: PropTypes.object,
  id: PropTypes.string,
  disabled: PropTypes.bool,
};

LabelledInput.defaultProps = {
  errorText: '',
  labelText: '',
  type: 'default',
  autoFocus: false,
  errorStyle: {},
  iconName: '',
  id: '',
  disabled: false,
};

export default LabelledInput;



// WEBPACK FOOTER //
// ./src/components/LabelledInput/LabelledInput.jsx